import React from 'react';
import { Modal, ModelHeader, ModalBody, ModalFooter } from '../../common/input/modal/Modal';
import logoimg from '../../assets/images/logo.png';

const QualificationModalView = (props) => {
    return (
        <>
            <Modal className="price-calculator-popup" show={props.modal_boolean} onHide={props.hideAvailablityModal}>
                <div className="modal-dialog modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="price-calculator-pop-cont-wrap">
                                <ModelHeader>
                                    <div className="price-calculator-pop-header">
                                        <h4>Required Training's</h4>
                                        <h6>Staff members have various qualifications, so to ensure you have a member who is best suited for your job please carefully go through the list and select the minimum qualifications that are necessary for a candidate to qualify for this post</h6>
                                    </div>
                                </ModelHeader>
                                <ModalBody>
                                    <div style={{padding:"10px 0 10px 28px"}}>
                                            <li style={{listStyleType: "none", textAlign : 'left'}}>
                                            <input type="checkbox" checked={props.select_all} onChange={props.selectAllHandler} style={{marginRight : '10px'}} />
                                            <label style={{wordWrap: 'break-word'}}>Select All</label>
                                            </li>
                                    </div>
                                    <div style={{textAlign:"center",padding:'0px 30px 0px'}} >
                                            <div className="row">
                                                {props.shift_select_list.map((shift_select_list, index) => (
                                                <div  style={{width: "50%", padding: "0px 13px"}}>
                                                    <li style={{listStyleType: "none", textAlign : 'left'}}>
                                                        <input checked={props.qualification_list.indexOf(shift_select_list.type) !== -1} onChange={(e) => props.availablitydada(e)} value={shift_select_list.type} style={{marginRight : '10px'}} id="checkid" type="checkbox" />
                                                        <label style={{wordWrap: 'break-word'}}>{shift_select_list.type}</label>
                                                    </li>
                                                </div>
                                                ))}
                                            </div>
                                              <div style={{padding:"20px 0"}}>
                                            <li style={{listStyleType: "none", textAlign : 'left'}}>
                                            <input type="checkbox" value="Candidate must have all the Trainings you specified above" checked={props.all_training} onChange={props.allTrainingHandle} style={{marginRight : '10px'}} />
                                            <label style={{wordWrap: 'break-word'}}>Candidate must have all the Trainings you specified above.</label>
                                            </li>
                                    </div>
                                    </div>
                                    <div className="row">
                                          <div className="col-lg-12" >
                                                <div className="login-form" >
                                                    <form>
                                                        <div className="field-box">
                                                            <button onClick={props.SummitAvailablity} type="button">Submit <i className="fa fa-sign-in"></i></button>
                                                        </div>
                                                    </form>
                                                </div>
                                          </div>
                                    </div>

                                </ModalBody>
                                <ModalFooter>
                                    <div className="wage-pop-footer">
                                        <div className="logo"><img src={logoimg} alt="" /></div>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default QualificationModalView;